export default __webpack_public_path__ + "static/media/yellow1.68a3879d.svg";